import type { ModalInfoProps } from '@/components/ModalInfo/ModalInfo';
import { ModalInfo } from '@/components';
import { Flex, Heading, Text } from '@blockanalitica/ui';

export default function StakingModal({ ...rest }: Partial<ModalInfoProps>) {
  return (
    <ModalInfo title="SKY Staking Information" {...rest}>
      <Flex flexDirection="column" gap="s">
        <Flex flexDirection="column" gap="xs">
          <Heading size="3">What is SKY Staking?</Heading>
          <Text size="2">
            When a user stakes their SKY tokens, they receive{' '}
            <b>Staking Rewards</b>. Staked SKY can be freely unstaked at any
            time. SKY staking rewards can be either USDS or SPK.
            <br />
            <br />
            When you stake SKY, you can also <b>borrow USDS</b> against your
            staked tokens—unlocking liquidity without losing staking rewards. At
            the same time, your staked SKY carries{' '}
            <b>governance voting power</b>, which you can either use directly to
            vote on proposals or delegate.
            <br />
            <br />
            Staking provides not just yield, but also liquidity access and
            active participation in protocol governance.
          </Text>
        </Flex>

        <Flex flexDirection="column" gap="xs">
          <Heading size="3">Why is the APY Variable?</Heading>
          <Text size="2">
            Staking Rewards Rates are variable and subject to change. The rate
            depends on both the amount of tokens being distributed (set by Sky
            Governance) and the live market price of the SKY token.
          </Text>
        </Flex>

        <Flex flexDirection="column" gap="xs">
          <Heading size="3">How is APY Determined?</Heading>
          <Text size="2">
            Staking Rewards Rate is determined by: <b>(1)</b> the current
            issuance rate of the rewards set through Sky&rsquo;s governance
            processes, and <b>(2)</b> the market price of the staked SKY at the
            time of each calculation.
          </Text>
        </Flex>

        <Flex flexDirection="column" gap="xs">
          <Heading size="3">Can I unstake anytime?</Heading>
          <Text size="2">Staked SKY can be freely unstaked at any time.</Text>
        </Flex>

        <Flex flexDirection="column" gap="xs">
          <Heading size="3">Can I borrow USDS against my SKY?</Heading>
          <Text size="2">
            SKY Staking allows users to borrow USDS against their SKY at the SKY
            Borrow Rate.
          </Text>
        </Flex>
      </Flex>
    </ModalInfo>
  );
}
